import React, {useEffect, useMemo, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {useGetDealers} from "../../api/get-dealers";
import {useAuth} from "../../../../../contexts/auth";
import {SelectBox} from "devextreme-react/select-box";
import {de} from "date-fns/locale";
import {Box, Item} from "devextreme-react/box";

export function DealerSelectorControl() {
    const context = useCountertops();
    const {user} = useAuth();
    const dealers = useGetDealers(user?.companyId ?? 0)
    const [selectedParent, setSelectedParent] = useState<number>(0);
    const filteredCompanies = useMemo(() => dealers.data.dealers.filter(c => c.parentCompanyID === selectedParent), [dealers.isLoading, selectedParent])

    useEffect(() => {
        if (dealers.isLoading)
            return;

        if (dealers.data.parentDealers.length === 1) {
            setSelectedParent(dealers.data.parentDealers[0].companyID);
        }
    }, [dealers.isLoading])

    return (
        <>
            <p className={"box-header"}>
                Dealer
            </p>
            <div>
                <Box direction="row"
                     width="100%"
                     align="start"
                     crossAlign="start"
                >
                    <Item baseSize={300}>
                        <SelectBox disabled={dealers.isLoading || dealers.data.parentDealers.length === 0}
                                   dataSource={dealers.data.parentDealers}
                                   displayExpr={(item) => {
                                       if (item === null)
                                           return '';

                                       return item.companyCode + ' - ' + item.companyName;
                                   }}
                                   value={selectedParent}
                                   searchEnabled={true}
                                   width={300}
                                   valueExpr="companyID" onValueChanged={(e) => {
                            if (dealers.data.dealers.length > 0) {
                                let item = dealers.data.parentDealers.find(element => element.companyID === e.value);
                                if (item === undefined) {
                                    return;
                                }

                                if (e.event === undefined) // value changed in context
                                    return;

                                setSelectedParent(item.companyID);
                                let ddealers = dealers.data.dealers.filter(element => element.parentCompanyID === e.value);
                                if (ddealers.length === 1) {
                                    context.setDealerId(ddealers[0].companyID);
                                } else {
                                    context.setDealerId(0);
                                }
                            }
                        }}></SelectBox>
                    </Item>
                    <Item>
                        <SelectBox disabled={dealers.isLoading || filteredCompanies.length === 0}
                                   style={{marginLeft: '10px'}}
                                   dataSource={filteredCompanies}
                                   displayExpr={(item) => {
                                       if (item === null)
                                           return '';

                                       return item.companyCode + ' - ' + item.companyName;
                                   }}
                                   value={context.dealerId}
                                   searchEnabled={true}
                                   width={300}
                                   valueExpr="companyID" onValueChanged={(e) => {
                            if (dealers.data.dealers.length > 0) {
                                let item = dealers.data.dealers.find(element => element.companyID === e.value);
                                if (item === undefined) {
                                    return;
                                }

                                if (e.event === undefined) // value changed in context
                                    return;

                                context.setDealerId(item.companyID);
                            }
                        }}></SelectBox>
                    </Item>
                </Box>
            </div>
        </>
    );
}
